
import Vue, { PropType } from 'vue'
import { getCallbotMaterialAudio } from '@/api/callbot'
import { CallbotMaterial } from '@/types/callbot'
import ZaIcon from './ZaIcon.vue'
import {
    MATERIAL_STATUS_LABELS,
    formatMaterialDate,
    formatMaterialDuration,
    formatMaterialSize,
} from './audioLibrary'

const HELP: Record<string, string> = {
    approved: 'Этот ролик можно выбирать при создании новых рассылок.',
    pending:
        'Ролик отправлен на проверку. После одобрения он появится в списке доступных аудио для рассылки.',
    rejected: 'Замените файл с учётом замечания и отправьте его на модерацию повторно.',
}

export default Vue.extend({
    name: 'MaterialDetailDialog',
    components: { ZaIcon },
    props: {
        value: { type: Boolean, default: false },
        projectId: { type: String, required: true },
        material: { type: Object as PropType<CallbotMaterial | null>, default: null },
        canManage: { type: Boolean, default: false },
    },
    data() {
        return {
            audioUrl: '',
            audioState: 'idle' as 'idle' | 'loading' | 'ready' | 'error',
            requestId: 0,
        }
    },
    computed: {
        statusLabel(): string {
            return this.material ? MATERIAL_STATUS_LABELS[this.material.status] : ''
        },
        statusIcon(): string {
            const status = this.material?.status
            return status === 'approved' ? 'check' : status === 'pending' ? 'clock' : 'error'
        },
        help(): string {
            return this.material ? HELP[this.material.status] : ''
        },
        duration(): string {
            return formatMaterialDuration(this.material?.durationSeconds ?? 0)
        },
        size(): string {
            return formatMaterialSize(this.material?.sizeBytes ?? 0)
        },
        uploaded(): string {
            return this.material ? formatMaterialDate(this.material.createdAt) : ''
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(open: boolean) {
                if (open) this.loadAudio()
                else this.releaseAudio()
            },
        },
        'material.id'() {
            if (this.value) this.loadAudio()
        },
    },
    beforeDestroy() {
        this.releaseAudio()
    },
    methods: {
        async loadAudio() {
            this.releaseAudio()
            if (!this.material) return
            const requestId = ++this.requestId
            this.audioState = 'loading'
            const blob = await getCallbotMaterialAudio(this.projectId, this.material.id)
            // Пока грузили, могли открыть другой ролик или закрыть карточку.
            if (requestId !== this.requestId) return
            if (!blob) {
                this.audioState = 'error'
                return
            }
            this.audioUrl = URL.createObjectURL(blob)
            this.audioState = 'ready'
        },
        releaseAudio() {
            this.requestId += 1
            if (this.audioUrl) URL.revokeObjectURL(this.audioUrl)
            this.audioUrl = ''
            this.audioState = 'idle'
        },
    },
})
